import React from 'react';
import BeaconComparableSplineChart from 'src/components/BeaconV2Components/BeaconMetricSplineChart/BeaconComparableSplineChart';
import AggregationBuilder from 'src/components/BeaconV2Components/utils/AggregationBuilder';
import { BEACON_INDEX_NAMES } from 'src/utils/entityDefinitions/indexes/beaconIndexNames';

const aggregationBuilder = (aggBuilder: AggregationBuilder): AggregationBuilder => {
  return aggBuilder.clearConditionRangeFilters().addConditionRangeFilter('unitsSold', 1);
};
export default function ProductsWithUnitsSoldSplineChart() {
  return (
    <BeaconComparableSplineChart
      title="Products with Units Sold"
      indexName={BEACON_INDEX_NAMES.SALES}
      fieldName="stacklineSku"
      primaryAggregationBuilder={aggregationBuilder}
      secondaryAggregationBuilder={aggregationBuilder}
    />
  );
}
